module.exports = __webpack_public_path__ + "img/order.f39c7b4c.svg";